// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',
    'received_invoice.button.save': 'Save',
    'received_invoice.button.download': 'Download PDF',
};
